import {notification} from "antd";

export enum NotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
}

export const showNotification = (message: string, type: NotificationType = NotificationType.INFO, options={}) => {
    notification[type]({
        message: message,
        placement: "bottomLeft",
        ...options
    });
};